export enum FolderCardVariants {
    CREATE = 'folder-create',
    COVER = 'folder-cover',
    NO_COVER = 'folder-no-cover',
    EMPTY_COVER = 'folder-empty-cover',
    EMPTY_NO_COVER = 'folder-empty-no-cover'
}

export enum ArticleCardVariants {
    MM_CREATE = 'article-mm-create',
    MM_PLACEHOLDER = 'article-mm-placeholder'
}

export enum TileCardVariants {
    SINGLE_TEXT = 'single-text',
    IMAGE_TEXT_LIGHT = 'image-text-light',
    IMAGE_TEXT_DARK = 'image-text-dark',
    SINGLE_IMAGE = 'single-image'
}

export enum CardTypes {
    FOLDER = 'folder',
    ARTICLE = 'article',
    TILE = 'tile',
    STORE = 'store'
}

export type CardProperties = {
    label: string;
    variant: string;
    icon?: string | string[];
    coverImg?: string;
    imgLabel?: string;
    imageList?: string[];
    actionsList?: {
        key: string;
        label: string;
    }[];
    payload?: any;
    hoverMode: 'none' | 'light' | 'dark';
};
